export default "__VITE_ASSET__C06t2QpX__"